


export class ContractsLookup {

    //static GetPrimeContract(id: number): string {
    //    switch (id) {
    //        case (1): return "Infrastructure";
    //        case (2): return "VITAL";
    //        case (3): return "NEURO";
    //        case (4): return "SLEEP";
    //        case (5): return "AUTONOMIC";
    //        case (6): return "ENERGIZE";
    //        default: return "Unknown";
    //    }
    //}

    static GetContractType(id: number): string {
        switch (id) {
            case (1): return "CDA";
            case (2): return "DUA";
            case (3): return "FUA";
            case (4): return "Funding Letter";
            case (5): return "LOI";
            case (6): return "License Agreement";
            case (7): return "MOU";
            case (8): return "MTA";
            case (9): return "Master Agreement";
            case (10): return "Member Agreement";
            case (11): return "Other";
            case (12): return "Site Agreement";
            case (13): return "Site Master Agreement";
            case (14): return "Support Services/Subcontract";
            case (15): return "Term Letter";
            case (16): return "Protocol Working Group";
            case (17): return "Study Coordinator Group";
            case (18): return "Site Study Contracts";
            case (19): return "Pre-Screening Agreement";
            case (20): return "Study Addendum - Site";
            case (21): return "Protocol Working Groups";
            default: return "Unknown";
        }
    }

    static GetContractStatus(id: number): string {
        switch (id) {
            case (1): return "DCRI e-IAF";
            case (2): return "Notified";
            case (3): return "In Draft-DCRI Contracts";
            case (4): return "In Neg - Risk Management";
            case (5): return "In Neg-DCRI";
            case (6): return "In Neg-DCRI Contracts";
            case (7): return "In Neg-Duke";
            case (8): return "In Neg-Ext Pty";
            case (9): return "In Neg-ORA";
            case (10): return "In Neg-ORC";
            case (11): return "In Neg-Procurement";
            case (12): return "In Neg-Sponsor";
            case (13): return "On Hold";
            case (14): return "On Hold-Cart";
            case (15): return "On Hold-Ext Pty";
            case (16): return "On Hold-K complete";
            case (17): return "On Hold-PL Attention Needed";
            case (18): return "On Hold-Pending Budget/Scope";
            case (19): return "On Hold-Pending SPA PA";
            case (20): return "In Sig - ORA";
            case (21): return "In Sig - ORC";
            case (22): return "In Sig - Procurement";
            case (23): return "In Sig-CM";
            case (24): return "In Sig-DCRI Contracts";
            case (25): return "In Sig-Ext Pty";
            case (26): return "Signed K Recd-DCRI Contracts";
            case (27): return "Signed K Recd-Duke";
            case (28): return "Signed K Recd-Ext. Party";
            case (29): return "Signed K Recd-ORA";
            case (30): return "Signed K Recd-ORC";
            case (31): return "Signed K Recd-Procurement";
            case (32): return "Executed-Contracts";
            case (33): return "Executed-Ext Pty";
            case (34): return "Executed-ORA";
            case (35): return "Executed-ORC";
            case (36): return "Executed-Procurement";
            case (37): return "Executed-Sponsor";
            case (38): return "Executed";
            case (39): return "Waiver Received";
            case (40): return "Withdrawn";
            case (41): return "In Draft-Ext Pty";
            case (42): return "Requested/Pending";
            case (43): return "In Sig - PI";
            case (44): return "Executed-PI";
            case (45): return "In Sig-Sponsor";
            case (46): return "In Sig-DCRI";
            case (47): return "Executed-CFO";
            case (48): return "CM Peer Review";
            case (49): return "On Hold-Pending GPS";
            case (50): return "Signed K Recd-Sponsor";
            case (51): return "On Hold-Pending Site IRB";
            case (52): return "Unknown";
            case (53): return "Signed K Recd-CFO";
            default: return "Unknown";
        }
    }

    static GetContractStatusGroup(id: number): string {
        switch (id) {
            case (1): return "Requested";
            case (2): return "Draft";
            case (3): return "Negotiation";
            case (4): return "On Hold";
            case (5): return "Signature";
            case (6): return "Waiver Received";
            case (7): return "Fully Executed";
            case (8): return "Withdrawn";
            case (9): return "Other";
            default: return "Unknown";
        }
    }
}